/*
 * Filename: d:\projects\AutoFiFront\src\Content\CGV\CGV.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Friday, January 20th 2023, 3:50:19 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import translator from 'MultiLanguage/TranslationWrapper';
import { BuildText } from 'Utils/BuildText';
import styles from "Content/CGV/CGV.module.css";

function CGV (_: any) {
    const legalObject = translator.decode("legal");
    const rows = BuildText(legalObject,"legal");

    return (
        <div className={`${styles.cgv}`}>
            <h1 className={`mt-3 ${styles.title}`}>{legalObject.title}</h1>
            {rows}
        </div>
    );
}

export default CGV;
